const HEX: Record<string, string> = {
  blue: '#1e5bd8',
  gray: '#8a9098',
  grey: '#8a9098',
  white: '#f4f4f2',
  yellow: '#f2c230',
  red: '#d8342c',
  green: '#2e9e4f',
  black: '#1a1a1a',
  orange: '#f07a1a',
  purple: '#7b4bc4',
  violet: '#7b4bc4',
  pink: '#ee7fb0',
  brown: '#7a4a2a',
  tan: '#d2b48c',
  beige: '#e8dcc0',
  silver: '#c0c4c8',
  clear: '#e8eef2',
};

export function colourHexFor(name: string | null | undefined): string | null {
  if (!name) return null;
  return HEX[name.trim().toLowerCase()] ?? null;
}
